import {TeambookCheckbox} from "../../default_components/TeambookCheckbox";
import {useState} from "react";
import {DateTime} from "luxon";

export default function FrontendStatisticsMeasurements({ frontendStatistics }) {
  const [excludeDuplicates, setExcludeDuplicates] = useState(false);

  const applyUniquenessFilter = (stats) => {
    const excludedUsers = [];

    return [...stats].reverse().filter((stat) => {
      if (excludeDuplicates) {
        if (excludedUsers.includes(stat.user_id)) {
          return false;
        } else {
          excludedUsers.push(stat.user_id);
          return true;
        }
      }

      return true;
    })
  }

  return (
    <div>
      <div>
        <p>Filter by date range</p>
      </div>

      <div>
        <p>Filter by users</p>

        <div className="flex">
          <div className="flex">
            <p>Exclude duplicate user records</p>
            <TeambookCheckbox checked={excludeDuplicates} onChange={() => setExcludeDuplicates(!excludeDuplicates)} />
          </div>
        </div>
      </div>

      {Object.keys(frontendStatistics).map((key) => {
        const stats = applyUniquenessFilter(frontendStatistics[key]);

        const lastWeekStats = stats.filter(stat => {
          const statDate = DateTime.fromISO(stat.date);
          const lastWeek = DateTime.now().minus({ days: 7 });

          return statDate >= lastWeek;
        });

        return (
          <div style={{borderBottom: "1px solid black"}}>
            <p>{key}</p>

            <p>Total: {stats.length}</p>

            <p>Last 7 days: {lastWeekStats.length}</p>
          </div>
        )
      })}
    </div>
  );
}
